<div *ngIf="block"
    class="container-avvisi bg-neutral-A1 position-relative m-3 d-flex flex-column justify-content-between no-print">
    <div>
        <div *ngIf="block.field_created_at" class="container-avvisi__badge position-absolute bg-support-50">
            <p class="m-0 ls-label-small-semibold text-neutral-A1 text-uppercase">
                {{ block.field_created_at | localizedDate: 'dd MMMM yyyy' }}
            </p>
        </div>
        <div *ngIf="block.created" class="container-avvisi__badge position-absolute bg-support-50">
            <p class="m-0 ls-label-small-semibold text-neutral-A1 text-uppercase">
                {{ block.created | localizedDate: 'dd MMMM yyyy' }}
            </p>
        </div>
        <div class="container-avvisi__category">
            <p class="ls-label-small-semibold text-neutral-60 text-uppercase" [innerHTML]="labelCategorySmall"></p>
            <a *ngIf="!isLinkEsternal && setTitle(block.field_titolo)"
                [routerLink]="navigationService.splitUrlRouterLink(setTitle(block.field_titolo).link).path" [queryParams]="navigationService.splitUrlRouterLink(setTitle(block.field_titolo).link).queryParams">
                <p class="ls-h3-item-title cursor-pointer text-brand-10" [innerHTML]="setTitle(block.field_titolo).title"></p>
            </a>
            <a *ngIf="isLinkEsternal && setTitle(block.field_titolo)" [href]="setTitle(block.field_titolo).link">
                <p class="ls-h3-item-title cursor-pointer text-brand-10" [innerHTML]="setTitle(block.field_titolo).title"></p>
            </a>
        </div>
    </div>
    <a *ngIf="!isLinkEsternal" [routerLink]="navigationService.splitUrlRouterLink(setTitle(block.field_titolo).link).path" [queryParams]="navigationService.splitUrlRouterLink(setTitle(block.field_titolo).link).queryParams">
        <div class="mt-5 line-discover-with-icon text-brand-40" style="min-width: 50%;">
            <p class="ls-label-medium-semibold text-brand-40 text-uppercase" [innerHTML]="'FIND_OUT' | translate"></p>
            <i class="fa-solid fa-arrow-right text-brand-40 pb-4" aria-hidden="true"></i>
        </div>
    </a>
    <a *ngIf="isLinkEsternal" [href]="setTitle(block.field_titolo).link" target="_blank">
        <div class="mt-5 line-discover-with-icon text-brand-40" style="min-width: 50%;">
            <p class="ls-label-medium-semibold text-brand-40 text-uppercase" [innerHTML]="'FIND_OUT' | translate"></p>
            <i class="fa-solid fa-arrow-right text-brand-40 pb-4" aria-hidden="true"></i>
        </div>
    </a>
</div>
<app-sample-print 
    [title]="setTitle(block.field_titolo).title" 
    [date]="block.field_created_at ? block.field_created_at : block.created"
    [modelDate]="'dd MMMM yyyy'">
</app-sample-print>
